import { ProductCode } from './ProductCode';

export type ProductGroup = 'investment' | 'pension';

export interface ProductType {
  code: ProductCode;
  group: ProductGroup;
  multiCompany: boolean;
  minInvestmentAmount?: number;
  productGroupId: number;
  productIdn?: string;
}

export const PRODUCT_IDNS = {
  BASIC: '000',
  PPK: '100',
  IKE: '202',
  IKE_KORPO: '212',
  IKZE: '302',
  IKZE_KORPO: '312',
};

export const allProductTypes: ProductType[] = [
  {
    code: ProductCode.basic,
    group: 'investment',
    multiCompany: false,
    minInvestmentAmount: 200,
    productGroupId: 0,
    productIdn: PRODUCT_IDNS.BASIC,
  },
  {
    code: ProductCode.ike,
    group: 'pension',
    multiCompany: false,
    minInvestmentAmount: 50,
    productGroupId: 1,
    productIdn: PRODUCT_IDNS.IKE,
  },
  {
    code: ProductCode.ikze,
    group: 'pension',
    multiCompany: false,
    minInvestmentAmount: 50,
    productGroupId: 2,
    productIdn: PRODUCT_IDNS.IKZE,
  },
  {
    code: ProductCode.ppe,
    group: 'pension',
    multiCompany: true,
    productGroupId: 4,
  },
  {
    code: ProductCode.ppk,
    group: 'pension',
    multiCompany: true,
    productGroupId: 5,
    productIdn: PRODUCT_IDNS.PPK,
  },
  {
    code: ProductCode.ppi,
    group: 'investment',
    multiCompany: true,
    productGroupId: 3,
  },
];

export const pensionProductTypes = allProductTypes
    .filter(productType => productType.group === 'pension');

export const investmentProductTypes = allProductTypes
    .filter(productType => productType.group === 'investment');

export const pensionProductCodes = pensionProductTypes
    .map(productType => productType.code.toString());

export const investmentProductCodes = investmentProductTypes
    .map(productType => productType.code.toString());

export const productTypesByGroup = (productGroup: ProductGroup): ProductType[] => {
  return allProductTypes.filter(productType => productType.group === productGroup);
};

export const getProductTypeByCode = (productCode: ProductCode): ProductType => {
  return allProductTypes.filter(productType => productType.code === productCode)[0];
};

export const isEmployerBasedProductType = (productType: ProductType): boolean => {
  return [ProductCode.ppe, ProductCode.ppi, ProductCode.ppk].includes(productType.code);
};

export const isMifidDependentProduct = (productCode: ProductCode): boolean => {
  return ![ProductCode.ppi, ProductCode.ppe, ProductCode.ppk].includes(productCode);
};

export const getProductCodeByString = (productCodeString: string): ProductCode | undefined => {
  const productCodeValue = productCodeString.toUpperCase();
  if (Object.values(ProductCode).some((pc: string) => pc === productCodeValue)) {
    return productCodeValue as ProductCode;
  } else {
    return undefined;
  }
};
